import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['María L.', 'Juan C.', 'Luciana G.', 'Martín R.', 'Carolina S.', 'Diego F.', 'Valeria M.', 'Sebastián P.', 'Florencia T.', 'Nicolás B.', 'Andrea V.', 'Pablo H.', 'Romina D.', 'Facundo A.', 'Gabriela N.', 'Alejandro K.', 'Daniela O.', 'Fernando E.', 'Soledad I.', 'Gustavo W.', 'Laura Z.', 'Hernán J.', 'Natalia Q.', 'Rodrigo U.', 'Cecilia X.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'San Luis', 'Corrientes', 'San Salvador de Jujuy', 'Río Cuarto', 'Tandil', 'Pergamino', 'Rafaela', 'Villa María'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function getRandomMinutes(): number {
  return Math.floor(Math.random() * 15) + 2;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: getRandomMinutes()
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
    }
    // First popup after 15 seconds
    const initialTimeout = setTimeout(showNotification, 15000);
    // Then every 35-50 seconds
    const interval = setInterval(() => {
      showNotification();
    }, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-408" data-mp="1a2d4xa6u0i21">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -100,
      y: 0
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-4 z-[60] max-w-xs" data-id="element-409" data-mp="19zh5tij8znc0">
          <div className="bg-bg-card rounded-[20px] shadow-2xl border border-line p-4 flex items-start gap-3" data-id="element-410" data-mp="20rg1u80t7g2n">
            <div className="w-10 h-10 bg-success/20 rounded-full flex items-center justify-center shrink-0" data-id="element-411" data-mp="24srw4qumoph6">
              <ShoppingBag size={20} className="text-success" data-id="element-412" data-mp="29tpd503wjdh3" />
            </div>
            <div data-id="element-413" data-mp="2eqxu4xdbdbgr">
              <p className="text-sm font-bold text-txt-primary" data-id="element-414" data-mp="2erhd8hepa5wd">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-txt-body" data-id="element-415" data-mp="fhhhfkjrask9">
                compró{' '}
                <span className="font-bold text-brandGold" data-id="element-416" data-mp="kgc10opjsl5f">
                  MEGAPACK Comercio Productivo 2026
                </span>
              </p>
              <p className="text-xs text-txt-muted mt-1" data-id="element-417" data-mp="83qepilq643g">
                hace {data.minutes} minutos
              </p>
            </div>
            <button onClick={() => setVisible(false)} className="text-txt-muted hover:text-txt-primary text-xs ml-auto shrink-0 mt-0.5" data-id="element-418" data-mp="356sri74ssb3">
              ✕
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}